// extracted by mini-css-extract-plugin
export default {"card":"BodyCard_card__4irL2"};